import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { environment } from '../environments/environment';
import { AngularFireDatabaseModule } from 'angularfire2/database';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';

import { AppComponent } from './app.component';
import { SharedModule } from './shared/shared.module';
import { SellerModule } from './seller/seller.module';
import { CoreModule } from './core/index';
import { AuthenticationModule } from './authentication/authentication.module';
import { HomedashboardComponent } from './seller/index';
import { GlobalEventsManager } from './app-global-events-manager';
import { BuyerModule } from './buyer/buyer.module';
import { AngularFireModule } from 'angularfire2';
import { FirebaseYasoService } from './core/firebase-yaso.service';
import { FirebaseHelperService } from './core/firebase/firebase-helper.service';
import { SellerHeaderComponent } from './seller/seller-header/seller-header.component';
import { WorkerModule } from './worker/worker.module';
import { WorkerHeaderComponent } from './worker/worker-header/worker-header.component';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { MobileRedirectionComponent } from './mobile-redirection/mobile-redirection.component';
import { CustomHttpInterceptorService } from './custominterceptor';
import localeSe from '@angular/common/locales/sv';
import { registerLocaleData } from '@angular/common';
registerLocaleData(localeSe);

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
 }

@NgModule({
  declarations: [
    AppComponent,
    HomedashboardComponent,
    SellerHeaderComponent,
    WorkerHeaderComponent,
    MobileRedirectionComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }}),
    AppRoutingModule,
    SharedModule,
    CoreModule,
    AuthenticationModule,
    BrowserAnimationsModule,
    SellerModule,
    BuyerModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireDatabaseModule,
    WorkerModule
  ],
  providers: [
    { provide: LOCALE_ID,
      useValue: 'sv-SE'
    },
    GlobalEventsManager,
    FirebaseYasoService,
    FirebaseHelperService,
    { provide: HTTP_INTERCEPTORS, useClass: CustomHttpInterceptorService, multi: true }
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts